(function () {
'use strict';

angular
  .module('hyresgastApp')
  .controller('NegotiationTableNegotiatorCurrentListCtrl', NegotiationTableNegotiatorCurrentListCtrl);

function NegotiationTableNegotiatorCurrentListCtrl(
  $location, $routeParams, $filter,
  FeatureConfiguration, CombinedNegotiationStates, NegotiationTypes,
  HyUtils,
  User, Negotiation
) {
  var vm = this;
  vm.FeatureConfiguration = FeatureConfiguration;

  vm.statusChoices = Object.values(CombinedNegotiationStates).map(x => ({
    id: x,
    text: $filter('hyCombinedNegotiationStates')(x)
  }));
  vm.negotiationTypeChoices = Object.values(NegotiationTypes).map(x => ({
    id: x,
    text: $filter('hyNegotiationTypes')(x)
  }));
  vm.columns = [
    { title: 'Id', column: 'caseNumber' },
    { title: 'Namn', column: 'negotiationName' },
    {
      title: 'Förhandlingstyp',
      template: 'slot1',
      column: 'type',
      lookup: {
        idProperty: 'id',
        textProperty: 'text',
        dictionary: vm.negotiationTypeChoices,
        multi: true,
      },
    },
    { title: 'Datum för framställan', column: 'createdAt' },
    {
      title: 'Status',
      template: 'status',
      column: 'combinedState',
      lookup: {
        idProperty: 'id',
        textProperty: 'text',
        dictionary: vm.statusChoices,
        multi: true,
      },
    },
    { title: 'Önskad hyresändring', column: 'rentEffectiveFrom' }
  ];
  if (vm.FeatureConfiguration.ENABLE_MEETINGS) {
    vm.listColumns.splice(4, 0, { title: 'Nästa möte', column: 'updatedAt' });
  }

  vm.gotoNegotiation = function (negotiation) {
    $location.search({});
    $location.path('/negotiations/' + negotiation.id);
  }

  vm.getData = function (params) {
    // eslint-disable-next-line no-undef, no-unused-vars
    return new Promise((resolve, reject) => {
      User.queryNegotiationsWithMe(Object.assign({
        partnerId: $routeParams.partnerId,
        'filters[counterpartOrganizationId]': $routeParams.organizationId,
      }, params)).$promise.then(function(data) {
        //TODO: replace with column.type = 'date'
        data.rows.forEach(x => {
          x.rentEffectiveFrom = $filter('date')(x.rentEffectiveFrom, 'yyyy-MM-dd');
          x.createdAt = $filter('date')(x.createdAt, 'yyyy-MM-dd');
        });
        resolve(data);
      });
    });
  }

  vm.editComment = negotiation => {
    HyUtils.showDefaultModal('EditCommentModalCtrl',
      'resources/agreement/rentlist/edit/edit-comment-modal.html',
      { comment: negotiation.comment, multipleComments: '' },
      result => {
        if (result.delete || result.comment) {
          negotiation.comment = result.delete ? '' : result.comment;
          Negotiation.saveComments([{
            negotiationId: negotiation.id,
            comment: negotiation.comment,
          }]);
          vm.isDirty = true;
        }
      }, null, null,
      { size: 'md' });
  };

  vm.getContextInfo = row => ({
    title: `Förhandling ${row.caseNumber}`,
    link: '/negotiations/'+row.id,
  });
}

})();